import React, { useRef, useState, useEffect } from "react";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

const EllipsisWithTooltip = ({ children }) => {
  const ref = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (node) {
      setIsOverflowing(node.offsetWidth < node.scrollWidth);
    }
  }, [children]);

  return (
    <div style={{ position: "relative" }}>
      <Typography
        component="p"
        ref={ref}
        sx={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {children}
      </Typography>
      {isOverflowing && (
        <Tooltip title={children} disableInteractive>
          <span
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default EllipsisWithTooltip;
